/** Mirrors the server rule for the preview `amount` query parameter (UX gate only). */
const VALID_AMOUNT = /^\d{1,8}(\.\d{1,2})?$/

/** Returns the trimmed amount when it is a valid preview amount, otherwise null. */
export function normalisePreviewAmount(raw: string): string | null {
  const trimmed = raw.trim()
  return VALID_AMOUNT.test(trimmed) ? trimmed : null
}
